import { useContext } from 'react'
import { gnarSpec } from '@lib/tracking/gnar'
import { LottiePlayerGnarEvents } from '@components/asset/lottie/hooks/types'
import { PageContext } from '@contexts/page-context'
import { PlacementContext } from '@contexts/placement-context'

export const useLottieGnarTracking = () => {
  const { pageId, slug } = useContext(PageContext)
  const { placement, placementInternalName } = useContext(PlacementContext)

  const events: LottiePlayerGnarEvents = {
    onAnimationLoaded: (meta) => {
      gnarSpec.animationInteractiveElementShow(pageId, slug, meta, placement, placementInternalName)
    },
  }

  return events
}
